import React from 'react';
import PropTypes from 'prop-types';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';

import s from './PowerBiDashboardView.module.scss';

const PowerBiDashboardView = ({ powerBIReportConfig }) => (
    <div className={s.powerBiDashboardView}>
        {powerBIReportConfig && (
            <PowerBIEmbed
                embedConfig={{
                    type: 'report',
                    id: powerBIReportConfig.id,
                    embedUrl: powerBIReportConfig.embedUrl,
                    accessToken: powerBIReportConfig.token,
                    tokenType: models.TokenType.Embed,
                }}
                cssClassName={s.embedContainer}
            />
        )}
    </div>
);

PowerBiDashboardView.propTypes = { powerBIReportConfig: PropTypes.object };

export default PowerBiDashboardView;
